<script>
  import axios from 'axios';
  import AS from '@/services/AuthenticationService';

  export default {
    all({ page, limit, q }) {
      return axios.get(`admin/configuracoes/usuarios?page=${ page }&limit=${ limit }&q=${ q }`, AS.getDefaultHeaders());
    },
    createOrUpdate(payload) {
      if (payload.id === '') {
        return axios.post('admin/configuracoes/usuarios', payload, AS.getDefaultHeaders());
      }
      return axios.patch(`admin/configuracoes/usuarios/${ payload.id }`, payload, AS.getDefaultHeaders());
    },
    resendConfirmationInstructions(id) {
      return axios.post(`admin/configuracoes/usuarios/${id}/resend_confirmation_instructions`, null, AS.getDefaultHeaders());
    }
  };
</script>
